import React from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { ProgramRichText } from '../program-rich-text/program-rich-text.component';

export const ProgramRules = ({ programRules }: { programRules: string }) => (
  <StackLayout spacing="$one">
    <ProgramRichText richText={programRules} />
  </StackLayout>
);
